<line-chart
  [customization]="customization()"
  [resource]="traffic"
  [metadata]="trafficMetadata()"
  [(dateRange)]="dateRangeOfInterest"
>
  <div chart-title class="chart__title-row">
    <h3 class="title-with-icon">
      <svg-icon src="assets/images/icons/chart.svg" class="black-medium"></svg-icon>
      <span>{{ "Chart.TrafficGraph" | translate }}</span>
    </h3>
  </div>
  <ng-container chart-header-left>
    <line-chart-subject-dropdown [subjects]="subjects()" [(selected)]="selectedSubject" />
  </ng-container>

  <ng-container chart-header-info>
    <div class="chart__current-traffic">
      <div class="chart__current-traffic-text">
        <span>{{ "ServiceElement.Chart.NowIn" | translate }}</span>
        {{ latestIn() | readable_size: mode() }}
      </div>
      <div class="chart__current-traffic-text">
        <span>{{ "ServiceElement.Chart.NowOut" | translate }}</span>
        {{ latestOut() | readable_size: mode() }}
      </div>
    </div>
  </ng-container>

  <ng-container chart-footer>
    <div class="chart__footer-controls">
      <line-chart-radio-buttons [options]="modeOptions" [(selected)]="mode" />
      <!-- Component hidden until because SNMP does not track multicast/broadcast well; reenable when switched to gNMI telemetry -->
      <!-- @if (false) {
        <custom-dropdown
          class="chart__packet-type-dropdown"
          [multiselect]="false"
          [options]="packetTypeOptions()"
          [searchable]="false"
          [disabled]="mode() !== 'pps'"
          (selectionChanged)="updatePacketType($event)"
        />
      } -->
    </div>
  </ng-container>
</line-chart>
